/** Odczytuje wymiary i rozdzielczość z nagłówka PNG. */
export function readPngInfo(data: Uint8Array): {
  widthPx:        number;
  heightPx:       number;
  pixelsPerMetre: number | null;
} {
  const r32 = (i: number) =>
    ((data[i] << 24) | (data[i+1] << 16) | (data[i+2] << 8) | data[i+3]) >>> 0;

  // IHDR jest zawsze pierwszym chunkiem (po 8-bajtowej sygnaturze)
  // 8(sig) + 4(len) + 4(type) = 16; width @16, height @20
  const widthPx  = r32(16);
  const heightPx = r32(20);

  // Szukaj chunku pHYs
  let pixelsPerMetre: number | null = null;
  let pos = 8;
  while (pos + 12 <= data.length) {
    const len  = r32(pos);
    const type = String.fromCharCode(data[pos+4], data[pos+5], data[pos+6], data[pos+7]);
    if (type === 'pHYs' && len >= 9) {
      const unit = data[pos + 8 + 8];   // 0 = unknown, 1 = metr
      if (unit === 1) pixelsPerMetre = r32(pos + 8);
    }
    if (type === 'IEND') break;
    pos += 12 + len;
  }

  return { widthPx, heightPx, pixelsPerMetre };
}
